import React, { PureComponent, PropTypes } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import { toggleFeature } from '../../../../store/settings/features/actions';
import { Container } from '../../../shared';
import FeatureList from './featureList';
import './styles.scss';

export class Features extends PureComponent {
  static propTypes = {
    setAndStartTimer: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.handleToggle = this.handleToggle.bind(this);
  }

  componentDidMount() {
    this.props.setAndStartTimer(30000);
  }

  handleToggle(key) {
    this.props.toggleFeature(key);
  }

  renderFeatures() {
    return Object.keys(this.props.features).map((key) => {
      const feature = this.props.features[key];
      if (!feature.shouldDisplay) {
        return null;
      }
      return (
        <FeatureList
          key={key}
          value={feature.value}
          title={feature.title}
          description={feature.description}
          onCheckboxToggle={() => this.handleToggle(key)}
        />);
    });
  }

  render() {
    return (
      <div className='features' key='featuresKey'>
        <Container>
          <ReactCSSTransitionGroup
            component='div'
            className='featureBlock'
            transitionName='pendingSlide'
            transitionAppear
            transitionEnter={false}
            transitionLeave={false}
            transitionAppearTimeout={400}
          >

            <div className="option-title">
              <h3><i className="fa fa-bolt" />Feature management</h3>
              <p>
                Choose the features you want on this time clock.
              </p>
            </div>

            <div className="option-body">
              {this.renderFeatures()}
            </div>
          </ReactCSSTransitionGroup>
        </Container>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    features: state.getIn(['settings', 'features']).toJS(),
  };
}

export default connect(mapStateToProps, { toggleFeature })(Features);



// WEBPACK FOOTER //
// ./src/components/timeclock/userhub/features/index.jsx